import router from '@/router'
import axios from 'axios'

/**
 * Only in-app paths are followed. A push payload is attacker-shaped input if a
 * sender is ever compromised, so absolute URLs are never navigated to.
 */
function toInternalPath (url) {
  if (typeof url !== 'string' || url === '') return null
  if (!url.startsWith('/') || url.startsWith('//')) return null
  return url
}

function reportOpened (logId) {
  if (!logId) return
  axios.post(`/api/notifications/${logId}/opened`).catch(() => {})
}

/**
 * Route to the screen a notification refers to. Called for taps, including the
 * cold start case where the tap is what launched the app, so it waits for the
 * router before navigating.
 */
export async function handleNotificationTap (data = {}) {
  reportOpened(data.log_id)

  const path = toInternalPath(data.url)
  if (!path) return

  try {
    await router.isReady()
    await router.push(path)
  } catch (e) {
    // A redundant navigation (already on the target) is not an error worth surfacing.
  }
}
